/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.162.0-v202607291944-CDH
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import type { SeeqRequestOverrides, SeeqErrorData } from '../variables';
import { getRuntime } from '../variables';
import type { AxiosPromise, AxiosError } from 'axios';
import { useMutation, useQuery, type UseMutationOptions, type UseMutationResult, type UseQueryOptions, type UseQueryResult } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import type * as models from '../model/models';

export class sqUsersApiClass {
 
   constructor() {}

  /**
   * @summary Search for users and groups by their names
   * @param {string} query - Part of user or group name to search for
   * @param {number} [offset=0] - The pagination offset, the index of the first collection item that will be returned in this page of results
   * @param {number} [limit=40] - The pagination limit, the total number of collection items that will be returned in this page of results
  */
  public autocompleteUsersAndGroups(
    {
      query,
      offset,
      limit
    } : {
      query: string,
      offset?: number,
      limit?: number
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (query === null || query === undefined) {
      throw new Error("'query' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/users/autocomplete/${encodeURIComponent(String(query))}`
      .replace('{query}', encodeURIComponent(String(query)));

    const queryParams = {
      ['offset']: offset,      ['limit']: limit
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.IdentityPreviewListV1>;
  }

  /**
   * @summary Create a user
  */
  public createUser(
    body: models.UserInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/users`;



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.UserOutputV1>;
  }

  /**
   * @summary Delete a user
   * @param {string} id - ID of the user to delete
   * @param {string} [newOwnerId] - ID of the user to take over ownership of items. If not specified and the user to delete has owned items, a &#x27;400 Bad Request&#x27; will be returned.
   * @param {boolean} [transferAclAndGroupMembership=false] - True if any ACL entries and group memberships for the user being deleted should be transferred to the new owner, false if ACL entries should be deleted and group memberships shouldn&#x27;t be transferred. When migrating users to a different authentication method, this should be set to true. When actually deleting a user, it should usually be set to false. The default is &#x27;false&#x27;.
  */
  public deleteUser(
    {
      id,
      newOwnerId,
      transferAclAndGroupMembership
    } : {
      id: string,
      newOwnerId?: string,
      transferAclAndGroupMembership?: boolean
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/users/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));

    const queryParams = {
      ['newOwnerId']: newOwnerId,      ['transferAclAndGroupMembership']: transferAclAndGroupMembership
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'delete',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Search for items shared with an identity. Items shared with groups the identity is a member of are also included. This endpoint will only return items explicitly shared with the identity and their groups. It does not return items an administrator has access to, by virtue of their administrator role, items an identity owns, or items that inherit their permissions. Can be used to get items scoped to a workbook or global items
   * @param {string} id - The ID of the identity to search for shared items
   * @param {Array<string>} types - A list of one or more case-sensitive item types which will restrict results to only those items that exactly match, or are children of, one of the specified types
   * @param {number} [offset=0] - The pagination offset, the index of the first collection item that will be returned in this page of results
   * @param {number} [limit=40] - The pagination limit, the total number of collection items that will be returned in this page of results
   * @param {string} [datasourceClass] - Optional datasource class to filter results by
   * @param {string} [datasourceId] - Optional datasource ID to filter results by, required if datasourceclass is specified
   * @param {string} [scopedTo] - An ID of a workbook to scope the results to. Returns only items scoped to that workbook. Can be combined with includeGlobal to also return globally scoped items. Not including either includeGlobal or scopedTo returns all items shared with identity.
   * @param {boolean} [includeGlobal=false] - Whether to include globally scoped items (items with no workbook scope). When used without scopedTo, returns only global items. When used with scopedTo, returns both workbook-scoped and global items.
  */
  public getItemsSharedWithIdentity(
    {
      id,
      types,
      offset,
      limit,
      datasourceClass,
      datasourceId,
      scopedTo,
      includeGlobal
    } : {
      id: string,
      types: Array<string>,
      offset?: number,
      limit?: number,
      datasourceClass?: string,
      datasourceId?: string,
      scopedTo?: string,
      includeGlobal?: boolean
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }

    if (types === null || types === undefined) {
      throw new Error("'types' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/users/items/${encodeURIComponent(String(id))}/sharedWithIdentity`
      .replace('{id}', encodeURIComponent(String(id)));

    const queryParams = {
      ['types']: types,      ['offset']: offset,      ['limit']: limit,      ['datasourceClass']: datasourceClass,      ['datasourceId']: datasourceId,      ['scopedTo']: scopedTo,      ['includeGlobal']: includeGlobal
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.ItemPreviewListV1>;
  }

  /**
   * @summary Search for items shared with the current user. Items shared with groups the user is a member of are also included. This endpoint will only return items explicitly shared with the user and their groups. It does not return items an administrator has access to, by virtue of their administrator role, items a user owns, or items that inherit their permissions. Can be used to get items scoped to a workbook or global items
   * @param {Array<string>} types - A list of one or more case-sensitive item types which will restrict results to only those items that exactly match, or are children of, one of the specified types
   * @param {number} [offset=0] - The pagination offset, the index of the first collection item that will be returned in this page of results
   * @param {number} [limit=40] - The pagination limit, the total number of collection items that will be returned in this page of results
   * @param {string} [datasourceClass] - Optional datasource class to filter results by
   * @param {string} [datasourceId] - Optional datasource ID to filter results by, required if datasourceClass is specified
   * @param {string} [scopedTo] - An ID of a workbook to scope the results to. Returns only items scoped to that workbook. Can be combined with includeGlobal to also return globally scoped items. Not including either includeGlobal or scopedTo returns all items shared with user.
   * @param {boolean} [includeGlobal=false] - Whether to include globally scoped items (items with no workbook scope). When used without scopedTo, returns only global items. When used with scopedTo, returns both workbook-scoped and global items.
  */
  public getItemsSharedWithMe(
    {
      types,
      offset,
      limit,
      datasourceClass,
      datasourceId,
      scopedTo,
      includeGlobal
    } : {
      types: Array<string>,
      offset?: number,
      limit?: number,
      datasourceClass?: string,
      datasourceId?: string,
      scopedTo?: string,
      includeGlobal?: boolean
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (types === null || types === undefined) {
      throw new Error("'types' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/users/items/sharedWithMe`;

    const queryParams = {
      ['types']: types,      ['offset']: offset,      ['limit']: limit,      ['datasourceClass']: datasourceClass,      ['datasourceId']: datasourceId,      ['scopedTo']: scopedTo,      ['includeGlobal']: includeGlobal
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.ItemPreviewListV1>;
  }

  /**
   * @summary Get the user that belongs to this authentication session
   * @param {boolean} [includeGroups=false] - Whether to include groups in the output
   * @param {boolean} [includeCapabilityInheritance=false] - Whether to include the inheritedFrom information in capabilityGrants output. When false, only the capability property is returned
  */
  public getMe(
    {
      includeGroups,
      includeCapabilityInheritance
    } : {
      includeGroups?: boolean,
      includeCapabilityInheritance?: boolean
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/users/me`;

    const queryParams = {
      ['includeGroups']: includeGroups,      ['includeCapabilityInheritance']: includeCapabilityInheritance
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.UserOutputV1>;
  }

  /**
   * @summary Get a user
   * @param {string} id - ID of the user to retrieve
   * @param {boolean} [includeGroups=true] - Whether to include groups in the output
   * @param {boolean} [includeCapabilities=false] - Whether to include granted capability information in the output, including group inheritance information (when applicable)
  */
  public getUser(
    {
      id,
      includeGroups,
      includeCapabilities
    } : {
      id: string,
      includeGroups?: boolean,
      includeCapabilities?: boolean
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/users/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));

    const queryParams = {
      ['includeGroups']: includeGroups,      ['includeCapabilities']: includeCapabilities
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.UserOutputV1>;
  }

  /**
   * @summary Search for user from a username
   * @param {string} authDatasourceClass - Auth datasource class of the user to retrieve
   * @param {string} authDatasourceId - Auth datasource id of the user to retrieve
   * @param {string} username - Username of the user to retrieve
   * @param {boolean} [includeGroups=false] - Whether to include groups in the output
  */
  public getUserFromUsername(
    {
      authDatasourceClass,
      authDatasourceId,
      username,
      includeGroups
    } : {
      authDatasourceClass: string,
      authDatasourceId: string,
      username: string,
      includeGroups?: boolean
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (authDatasourceClass === null || authDatasourceClass === undefined) {
      throw new Error("'authDatasourceClass' parameter required");
    }

    if (authDatasourceId === null || authDatasourceId === undefined) {
      throw new Error("'authDatasourceId' parameter required");
    }

    if (username === null || username === undefined) {
      throw new Error("'username' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/users/search`;

    const queryParams = {
      ['authDatasourceClass']: authDatasourceClass,      ['authDatasourceId']: authDatasourceId,      ['username']: username,      ['includeGroups']: includeGroups
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.UserOutputV1>;
  }

  /**
   * @summary Get a collection of users
   * @param {string} [usernameSearch] - Search text by which to filter users&#x27; names.
   * @param {string} [emailSearch] - Search text by which to filter users&#x27; email addresses.
   * @param {string} [firstNameSearch] - Search text by which to filter users&#x27; first names.
   * @param {string} [lastNameSearch] - Search text by which to filter users&#x27; last names.
   * @param {string} [datasourceNameSearch] - Search text by which to filter users&#x27; directories.
   * @param {boolean} [isAdmin] - Whether to filter users to only users who are administrators.
   * @param {boolean} [isEnabled] - Whether to filter users to only users who are enabled.
   * @param {boolean} [isLoggedIn] - Whether to filter users to only users who are logged in.
   * @param {boolean} [isCreated] - Whether to filter users to only users who are not system managed.
   * @param {string} [sortOrder=email asc] - A field by which to order the users followed by a space and &#x27;asc&#x27; or &#x27;desc&#x27;. Field name can be one of: username, email, firstName, lastName, datasourceName
   * @param {number} [offset=0] - The pagination offset, the index of the first collection item that will be returned in this page of results
   * @param {number} [limit=40] - The pagination limit, the total number of collection items that will be returned in this page of results
   * @param {boolean} [isPasswordResetRequested] - Whether to filter users to only users who are required to change their password on next login.
   * @param {string} [roleSearch] - User role
   * @param {string} [manager] - Manager ID
   * @param {string} [siteSearch] - Site
  */
  public getUsers(
    {
      usernameSearch,
      emailSearch,
      firstNameSearch,
      lastNameSearch,
      datasourceNameSearch,
      isAdmin,
      isEnabled,
      isLoggedIn,
      isCreated,
      sortOrder,
      offset,
      limit,
      isPasswordResetRequested,
      roleSearch,
      manager,
      siteSearch
    } : {
      usernameSearch?: string,
      emailSearch?: string,
      firstNameSearch?: string,
      lastNameSearch?: string,
      datasourceNameSearch?: string,
      isAdmin?: boolean,
      isEnabled?: boolean,
      isLoggedIn?: boolean,
      isCreated?: boolean,
      sortOrder?: string,
      offset?: number,
      limit?: number,
      isPasswordResetRequested?: boolean,
      roleSearch?: string,
      manager?: string,
      siteSearch?: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/users`;

    const queryParams = {
      ['usernameSearch']: usernameSearch,      ['emailSearch']: emailSearch,      ['firstNameSearch']: firstNameSearch,      ['lastNameSearch']: lastNameSearch,      ['datasourceNameSearch']: datasourceNameSearch,      ['isAdmin']: isAdmin,      ['isEnabled']: isEnabled,      ['isLoggedIn']: isLoggedIn,      ['isCreated']: isCreated,      ['sortOrder']: sortOrder,      ['offset']: offset,      ['limit']: limit,      ['isPasswordResetRequested']: isPasswordResetRequested,      ['roleSearch']: roleSearch,      ['manager']: manager,      ['siteSearch']: siteSearch
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.UserOutputListV1>;
  }

  /**
   * @summary Update password for a user authenticating through Seeq
   * @param {string} id - ID of the user to set password for
  */
  public updatePassword(
    body: models.UserPasswordInputV1,
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/users/${encodeURIComponent(String(id))}/password`
      .replace('{id}', encodeURIComponent(String(id)));



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.UserOutputV1>;
  }

  /**
   * @summary Update a user
   * @param {string} id - ID of the user to update
  */
  public updateUser(
    body: models.UserInputV1,
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/users/${encodeURIComponent(String(id))}/update`
      .replace('{id}', encodeURIComponent(String(id)));



    return axiosInstance.request({
      method: 'post',
      url,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.UserOutputV1>;
  }

}


export const sqUsersApi = new sqUsersApiClass();

export type sqUsersApiEndpoints = {
  'autocompleteUsersAndGroups': {
    method: 'get';
    path: '/users/autocomplete/${encodeURIComponent(String(query))}';
    response: models.IdentityPreviewListV1;
  };
  'createUser': {
    method: 'post';
    path: '/users';
    response: models.UserOutputV1;
  };
  'deleteUser': {
    method: 'delete';
    path: '/users/${encodeURIComponent(String(id))}';
    response: models.StatusMessageBase;
  };
  'getItemsSharedWithIdentity': {
    method: 'get';
    path: '/users/items/${encodeURIComponent(String(id))}/sharedWithIdentity';
    response: models.ItemPreviewListV1;
  };
  'getItemsSharedWithMe': {
    method: 'get';
    path: '/users/items/sharedWithMe';
    response: models.ItemPreviewListV1;
  };
  'getMe': {
    method: 'get';
    path: '/users/me';
    response: models.UserOutputV1;
  };
  'getUser': {
    method: 'get';
    path: '/users/${encodeURIComponent(String(id))}';
    response: models.UserOutputV1;
  };
  'getUserFromUsername': {
    method: 'get';
    path: '/users/search';
    response: models.UserOutputV1;
  };
  'getUsers': {
    method: 'get';
    path: '/users';
    response: models.UserOutputListV1;
  };
  'updatePassword': {
    method: 'post';
    path: '/users/${encodeURIComponent(String(id))}/password';
    response: models.UserOutputV1;
  };
  'updateUser': {
    method: 'post';
    path: '/users/${encodeURIComponent(String(id))}/update';
    response: models.UserOutputV1;
  };
};

type ApiAutocompleteUsersAndGroupsResponse = models.IdentityPreviewListV1;
export function AutocompleteUsersAndGroupsQueryKey(
  params: Parameters<typeof sqUsersApi.autocompleteUsersAndGroups>[0],
) {
  return ['sqUsersApi', 'autocompleteUsersAndGroups', params] as const;
}

export function useApiAutocompleteUsersAndGroupsQuery(
  params: Parameters<typeof sqUsersApi.autocompleteUsersAndGroups>[0],
  options?: Omit<UseQueryOptions<ApiAutocompleteUsersAndGroupsResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiAutocompleteUsersAndGroupsResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: AutocompleteUsersAndGroupsQueryKey(params),
    queryFn: () =>
      sqUsersApi.autocompleteUsersAndGroups(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiCreateUserResponse = models.UserOutputV1;
type ApicreateUserMutationParams = Parameters<typeof sqUsersApi.createUser> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqUsersApi.createUser>;
type ApicreateUserMutationVariables = models.UserInputV1;

export function useApiCreateUserMutation(
  options?: Omit<UseMutationOptions<ApiCreateUserResponse, AxiosError<SeeqErrorData>,
    ApicreateUserMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiCreateUserResponse, AxiosError<SeeqErrorData>,
  ApicreateUserMutationVariables> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (body: ApicreateUserMutationVariables) =>
      sqUsersApi.createUser(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiDeleteUserResponse = models.StatusMessageBase;
type ApideleteUserMutationParams = Parameters<typeof sqUsersApi.deleteUser> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqUsersApi.deleteUser>;

export function useApiDeleteUserMutation(
  options?: Omit<UseMutationOptions<ApiDeleteUserResponse, AxiosError<SeeqErrorData>,
    ApideleteUserMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiDeleteUserResponse, AxiosError<SeeqErrorData>,
  ApideleteUserMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    
    mutationFn: (params: ApideleteUserMutationParams) =>
      sqUsersApi.deleteUser(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiGetItemsSharedWithIdentityResponse = models.ItemPreviewListV1;
export function GetItemsSharedWithIdentityQueryKey(
  params: Parameters<typeof sqUsersApi.getItemsSharedWithIdentity>[0],
) {
  return ['sqUsersApi', 'getItemsSharedWithIdentity', params] as const;
}

export function useApiGetItemsSharedWithIdentityQuery(
  params: Parameters<typeof sqUsersApi.getItemsSharedWithIdentity>[0],
  options?: Omit<UseQueryOptions<ApiGetItemsSharedWithIdentityResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetItemsSharedWithIdentityResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetItemsSharedWithIdentityQueryKey(params),
    queryFn: () =>
      sqUsersApi.getItemsSharedWithIdentity(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetItemsSharedWithMeResponse = models.ItemPreviewListV1;
export function GetItemsSharedWithMeQueryKey(
  params: Parameters<typeof sqUsersApi.getItemsSharedWithMe>[0],
) {
  return ['sqUsersApi', 'getItemsSharedWithMe', params] as const;
}

export function useApiGetItemsSharedWithMeQuery(
  params: Parameters<typeof sqUsersApi.getItemsSharedWithMe>[0],
  options?: Omit<UseQueryOptions<ApiGetItemsSharedWithMeResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetItemsSharedWithMeResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetItemsSharedWithMeQueryKey(params),
    queryFn: () =>
      sqUsersApi.getItemsSharedWithMe(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetMeResponse = models.UserOutputV1;
export function GetMeQueryKey(
  params: Parameters<typeof sqUsersApi.getMe>[0],
) {
  return ['sqUsersApi', 'getMe', params] as const;
}

export function useApiGetMeQuery(
  params: Parameters<typeof sqUsersApi.getMe>[0],
  options?: Omit<UseQueryOptions<ApiGetMeResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetMeResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetMeQueryKey(params),
    queryFn: () =>
      sqUsersApi.getMe(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetUserResponse = models.UserOutputV1;
export function GetUserQueryKey(
  params: Parameters<typeof sqUsersApi.getUser>[0],
) {
  return ['sqUsersApi', 'getUser', params] as const;
}

export function useApiGetUserQuery(
  params: Parameters<typeof sqUsersApi.getUser>[0],
  options?: Omit<UseQueryOptions<ApiGetUserResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetUserResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetUserQueryKey(params),
    queryFn: () =>
      sqUsersApi.getUser(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetUserFromUsernameResponse = models.UserOutputV1;
export function GetUserFromUsernameQueryKey(
  params: Parameters<typeof sqUsersApi.getUserFromUsername>[0],
) {
  return ['sqUsersApi', 'getUserFromUsername', params] as const;
}

export function useApiGetUserFromUsernameQuery(
  params: Parameters<typeof sqUsersApi.getUserFromUsername>[0],
  options?: Omit<UseQueryOptions<ApiGetUserFromUsernameResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetUserFromUsernameResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetUserFromUsernameQueryKey(params),
    queryFn: () =>
      sqUsersApi.getUserFromUsername(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetUsersResponse = models.UserOutputListV1;
export function GetUsersQueryKey(
  params: Parameters<typeof sqUsersApi.getUsers>[0],
) {
  return ['sqUsersApi', 'getUsers', params] as const;
}

export function useApiGetUsersQuery(
  params: Parameters<typeof sqUsersApi.getUsers>[0],
  options?: Omit<UseQueryOptions<ApiGetUsersResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseQueryResult<ApiGetUsersResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useQuery({
    queryKey: GetUsersQueryKey(params),
    queryFn: () =>
      sqUsersApi.getUsers(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiUpdatePasswordResponse = models.UserOutputV1;
type ApiupdatePasswordMutationParams = Parameters<typeof sqUsersApi.updatePassword> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqUsersApi.updatePassword>;

export function useApiUpdatePasswordMutation(
  options?: Omit<UseMutationOptions<ApiUpdatePasswordResponse, AxiosError<SeeqErrorData>,
    ApiupdatePasswordMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiUpdatePasswordResponse, AxiosError<SeeqErrorData>,
  ApiupdatePasswordMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApiupdatePasswordMutationParams) =>
      sqUsersApi.updatePassword(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiUpdateUserResponse = models.UserOutputV1;
type ApiupdateUserMutationParams = Parameters<typeof sqUsersApi.updateUser> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqUsersApi.updateUser>;

export function useApiUpdateUserMutation(
  options?: Omit<UseMutationOptions<ApiUpdateUserResponse, AxiosError<SeeqErrorData>,
    ApiupdateUserMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
  },
): UseMutationResult<ApiUpdateUserResponse, AxiosError<SeeqErrorData>,
  ApiupdateUserMutationParams> {
  const { axiosInstance, silent, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = { axiosInstance: axiosInstance ?? ctxAxiosInstance, silent };
  return useMutation({
    mutationFn: (params: ApiupdateUserMutationParams) =>
      sqUsersApi.updateUser(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
